import React, {createRef, RefObject} from 'react'
import {findDOMNode} from "react-dom"
import PopoverComponent, {PopoverComponentProps, PopoverComponentState} from "../../base-component/popover-component"

import Popover from "../../gd-popover/popover-v2"
import PopoverPosition from "../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../gd-popover/@const"
import VScroll from "../../scrolling/custom-v-scroll/v-scroll"
import SortInfo from "../../popover-menu/popover-help-hint/popover-help-hint-depricated"

import HintPopover from "../../../gd-ui/hint-popover/hint-popover"

type Props = PopoverComponentProps & {
    size?               : 'normal'|'fixed-150'| 'controls'| 'fixed-110-26'| 'controls-22'

    type?               : 'default'|'default-square'|'icon-only'|'static-icon-label'|'no-border'|'underlined'|'top-control'| 'top-control-2'| 'control-main-selector'
    icon?               : string

    staticLabel?        : string // static-icon-label type only

    items?              : any[]
    selectedId?         : any
    onChange?           : callback

    placeHolder?        : string
    hint?               : string
    defaultInfo?        : string

    attachment?         : string
    targetAttachment?   : string

    popoverClassName?   : string
    className?          : string
    style?              : any
}

type State = PopoverComponentState

// THIS IS DEPRICATED - what is new one ?
export default class SelectorWithInfo extends PopoverComponent<Props, State> {

    private sortInfoRef: RefObject<any> = createRef()

    static defaultProps: Partial<Props> = {
        size: 'normal',
        type: 'default',
        placeHolder: '',
        attachment: 'top center',
        targetAttachment: 'bottom center',
        style: {}
    }

    handleHoverOn = (info:string) => {
        if (this.sortInfoRef.current) this.sortInfoRef.current.setMessage(info)
    }

    handleHoverOff = () => {
        if (this.sortInfoRef.current) this.sortInfoRef.current.setMessage(null)
    }

    onOptionClick = (id:any, e:any) => {
        e.stopPropagation()
        this.hidePopover(e,()=>{
            if (this.props.onChange) this.props.onChange(id)
        })
    }

    renderOptionItems = () => {
        return this.props.items && this.props.items.map((i,key)=>{

            const selected = this.props.selectedId ? this.props.selectedId === i.id : i.id === null
            const classes = Classes('action', {
                selected: selected,
                'with-icon': !!i.icon
            })

            return (
                <div key={key+"_"+i.id}
                     className={classes}
                     onMouseEnter={this.handleHoverOn.bind(this, i.info)}
                     onMouseLeave={this.handleHoverOff}
                     onClick={this.onOptionClick.bind(this,i.id)}>
                    {!!i.icon && <div className={Classes("action-icon", i.icon)} />}
                    {i.label}
                </div>
            )
        })
    }

    renderPopover = () => {
        if (this.state.showPopover) {
            const option = _.find(this.props.items, i=>i.id === this.props.selectedId)
            const defaultMessage = option && option.info ? option.info : this.props.defaultInfo

            const popoverPosition = new PopoverPosition({
                attachment      : this.props.attachment,
                targetAttachment: this.props.targetAttachment,
                attachmentType  : PopoverAttachmentType.HORIZONTAL,
            })

            return (
                <Popover className="gd-selector-with-info-container"
                         popoverClass={Classes("gd-selector-with-info-popover", this.props.popoverClassName)}
                         position={popoverPosition}
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={()=>findDOMNode(this)}>

                    <VScroll className="gd-popup-menu-items"
                             scrollVisibility="auto">
                        {this.renderOptionItems()}
                    </VScroll>

                    {defaultMessage &&
                    <SortInfo ref={this.sortInfoRef}
                              defaultMessage={defaultMessage}
                              noBorder={true}/>}

                </Popover>
            )
        } else {
            return null
        }
    }

    renderLabel = () => {
        let res

        switch (this.props.type) {
            case 'default':
            case 'default-square':
            case 'no-border':
            case 'underlined':
                const option = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null
                let label:any = this.props.placeHolder
                if (option) {
                    const labelClasses = Classes("gd-selector-with-info-label", {
                        'is-default': option.default
                    })
                    const text = option.valueLabel ? option.valueLabel : option.label
                    label = <div className={labelClasses}>{text}</div>
                }

                res = (
                    <div className="gd-selector-with-info-button">
                        {label}
                        <div className="gd-selector-with-info-icon i5-big-angle-down"> </div>
                    </div>
                )
                break

            case 'icon-only':
                res = (
                    <div className="gd-selector-with-info-button">
                        <div className={Classes("gd-selector-with-info-icon ", this.props.icon)}> </div>
                    </div>
                )
                break

            case 'static-icon-label':
                res = (
                    <div className="gd-selector-with-info-button">
                        <div className={Classes("gd-selector-with-info-icon ", this.props.icon)}> </div>
                        {this.props.staticLabel}
                    </div>
                )
                break

            case 'top-control': {
                const option:any = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null

                res = (
                    <div className="btn with-text no-default-margin">
                        {option.icon && <div className={option.icon}/>}
                        <div className="label ui5-txt-not-important m-l-5">{option.label}</div>
                    </div>
                )
            } break

            case 'top-control-2': {
                const option:any = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null

                res = (
                    <div className="btn with-text no-decoration no-default-margin selected">
                        {option.icon && <div className={option.icon}/>}
                        <div className="label ui5-txt-not-important m-l-10">{option.label}</div>
                        <div className="arrow ui5-arrow-toggle s8 open m-l-5"/>
                    </div>
                )
            } break

            case 'control-main-selector': {
                const option:any = this.props.selectedId ? _.find(this.props.items, o=>o.id === this.props.selectedId) : null

                res = (
                    <div className="gd-selector-with-info-button">
                        {option.icon && <div className={option.icon}/>}
                        <div className="label ui5-txt-not-important m-l-10">{option.label}</div>
                        <div className="arrow ui5-arrow-toggle s8 open m-l-5"/>
                    </div>
                )
            }
        }

        return res
    }

    render() {
        const classes = Classes("gd-selector-with-info", this.props.size+"-size", this.props.type+"-type", this.props.className, {
            "is-selected": !!this.props.selectedId
        })

        return (
            <div className={classes} style={this.props.style} onClick={this.togglePopover}>
                {this.renderLabel()}
                {this.renderPopover()}
                {this.props.hint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.hint}/> }
            </div>
        )
    }
}
